var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 4C3.25 2.48122 4.48122 1.25 6 1.25H18C19.5188 1.25 20.75 2.48122 20.75 4V7C20.75 7.41421 20.4142 7.75 20 7.75C19.5858 7.75 19.25 7.41421 19.25 7V4C19.25 3.30964 18.6904 2.75 18 2.75H6C5.30964 2.75 4.75 3.30964 4.75 4V20.8532L7.69939 19.5629C7.89103 19.479 8.10897 19.479 8.30061 19.5629L12 21.1814L15.6994 19.5629C15.891 19.479 16.109 19.479 16.3006 19.5629L19.25 20.8532V11C19.25 10.5858 19.5858 10.25 20 10.25C20.4142 10.25 20.75 10.5858 20.75 11V22C20.75 22.2531 20.6223 22.4891 20.4105 22.6277C20.1987 22.7662 19.9313 22.7886 19.6994 22.6871L16 21.0686L12.3006 22.6871C12.109 22.771 11.891 22.771 11.6994 22.6871L8 21.0686L4.30061 22.6871C4.06873 22.7886 3.80132 22.7662 3.58949 22.6277C3.37766 22.4891 3.25 22.2531 3.25 22V4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 11C5.75 10.5858 6.08579 10.25 6.5 10.25H13C13.4142 10.25 13.75 10.5858 13.75 11C13.75 11.4142 13.4142 11.75 13 11.75H6.5C6.08579 11.75 5.75 11.4142 5.75 11Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 15C5.75 14.5858 6.08579 14.25 6.5 14.25H13C13.4142 14.25 13.75 14.5858 13.75 15C13.75 15.4142 13.4142 15.75 13 15.75H6.5C6.08579 15.75 5.75 15.4142 5.75 15Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 11C14.75 10.5858 15.0858 10.25 15.5 10.25H17.5C17.9142 10.25 18.25 10.5858 18.25 11C18.25 11.4142 17.9142 11.75 17.5 11.75H15.5C15.0858 11.75 14.75 11.4142 14.75 11Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 15C14.75 14.5858 15.0858 14.25 15.5 14.25H17.5C17.9142 14.25 18.25 14.5858 18.25 15C18.25 15.4142 17.9142 15.75 17.5 15.75H15.5C15.0858 15.75 14.75 15.4142 14.75 15Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 7C5.75 6.58579 6.08579 6.25 6.5 6.25H13C13.4142 6.25 13.75 6.58579 13.75 7C13.75 7.41421 13.4142 7.75 13 7.75H6.5C6.08579 7.75 5.75 7.41421 5.75 7Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 7C14.75 6.58579 15.0858 6.25 15.5 6.25H17.5C17.9142 6.25 18.25 6.58579 18.25 7C18.25 7.41421 17.9142 7.75 17.5 7.75H15.5C15.0858 7.75 14.75 7.41421 14.75 7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.62b094413a687a047f0a1c1663c11b12.svg";
export { ForwardRef as ReactComponent };